import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePutScrapParams, TypePutScrapResponse } from '~/types/receive.types';

/**
 * [입고관리 > 회송/폐기 관리] 폐기 처리 신청 API
 * @note 에러 처리는 사용처(모달)에서 개별 토스트로 처리한다.
 */
const fetchPutReturnDisposalScrap = async (params: TypePutScrapParams): Promise<{ inspectionIds: number[] }> => {
  const { data } = await axiosInstance.put<TypePutScrapResponse>(
    API_ENDPOINT.RECEIVE.PUT_RETURN_DISPOSAL_SCRAP,
    params
  );

  return data.data;
};

/**
 * [입고관리 > 회송/폐기 관리] 폐기 처리 신청 Mutation Hook
 */
export const usePutReturnDisposalScrapMutation = () => {
  return useMutation({
    mutationFn: fetchPutReturnDisposalScrap,
    meta: { showGlobalErrorToast: false },
  });
};

/**
 * [입고관리 > 회송/폐기 관리] 폐기 처리 신청 Mock
 */
registerMockAPI<TypePutScrapResponse | TypeErrorResponseData>({
  method: 'put',
  endpoint: API_ENDPOINT.RECEIVE.PUT_RETURN_DISPOSAL_SCRAP,
  label: '회송폐기관리/폐기 신청',
  scenarios: [
    {
      name: '신청 성공',
      response: { data: { inspectionIds: [1, 2] } },
    },
    {
      name: '서버 에러 (500)',
      response: { error: { code: 500, message: '신청에 실패했습니다.\n다시 시도해주세요.' } },
      status: 500,
    },
  ],
});
